module.exports = __webpack_public_path__ + "img/zhyldyz-academy-1.8b179727.jpeg";